import React, { useEffect, useState } from "react";
import {
  Wrapper,
  Col1,
  Title,
  NewProductButton,
  Row,
  Field,
  Card,
  SubTitle,
  CustomLabel,
  CustomIcon,
  Action,
  LoadingWrapper,
  Span,
  DeleteButton,
  Strong,
  ModalWrapper,
  CustomAlert,
} from "./style";
import { useDispatch } from "react-redux";
import { Icon, Input, Loading } from "../../../components/common";
import { SelectInput } from "vqp-common";
import {
  fetchCupons,
  removeCupom,
  statusCupom,
} from "../../../redux/actions/coupon";
import useFetch from "../../../utils/useFetch";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import FilterListIcon from "@material-ui/icons/FilterList";
import { InfoCupomModal, RenewCupomModal } from "./CupomModal";
import { Dialog, DialogContent } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { useHistory, Link } from "react-router-dom";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "cod", numeric: false, disablePadding: false, label: "Código" },
  { id: "name", numeric: false, disablePadding: false, label: "Nome" },
  {
    id: "establishment",
    numeric: false,
    disablePadding: false,
    label: "Estabelecimento",
  },
  { id: "app", numeric: false, disablePadding: false, label: "Aplicativo" },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
  { id: "actions", numeric: false, disablePadding: false, label: "Ações" },
];

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography
          className={classes.title}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          className={classes.title}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Nutrition
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton aria-label="delete">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton aria-label="filter list">
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    fontSize: "12px",
    minWidth: "auto",
  },
  tablecell: {
    fontSize: "12px",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

const CouponsSearchPage = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [cupons, setCoupons] = useState([]);
  const [rows, setRows] = useState([]);
  const [cuponsFilter, setCouponsFilter] = useState(null);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [establishments, setEstablishments] = useState("");
  const classes = useStyles();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [selectedCupom, setSelectedCupom] = useState(null);
  const [infoCupomOpen, setInfoCupomOpen] = useState(false);
  const [renewCupomOpen, setRenewCupomOpen] = useState(false);
  const [deleteCupomOpen, setDeleteCupomOpen] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMenssage, setSnackbarMenssage] = useState(false);
  const history = useHistory();
  const data = useFetch(fetchCupons);

  useEffect(() => {
    if (data) {
      setCoupons(data.response);
      setRows(data.response);
    } else {
      setRows([]);
    }
  }, [cuponsFilter, data, cupons]);

  const optionStatusCupom = [
    {
      value: 0,
      name: "Todos",
    },
    {
      value: 1,
      name: "Ativo",
    },
    {
      value: 2,
      name: "Inativo",
    },
    {
      value: 3,
      name: "Utilizado",
    },
    {
      value: 2,
      name: "Expirado",
    },
  ];
  const handleEditCupom = (cupomId) => {
    history.push({
      pathname: `/cupom-cadastro`,
      state: { id: cupomId },
    });
  };

  const handleAddCupom = () => {
    history.push({ pathname: `/cupom-cadastro` });
  };

  const handleClickSnackbar = () => {
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };

  const getStatus = () => {
    if (status === 0) return "";
    else if (status === 1) return "Ativo";
    else if (status === 2) return "Inativo";
    else if (status === 3) return "Utilizado";
    else if (status === 4) return "Expirado";
    else return "";
  };

  const handleFilterCupons = () => {
    const cuponsFil = cupons.filter((item) => {
      let filterCode =
        item.cod.toString().toLowerCase().indexOf(code.toLowerCase()) !== -1;
      let filterName =
        item.name.toLowerCase().indexOf(name.toLowerCase()) !== -1;
      let filterEstablishment =
        item.establishment
          .toLowerCase()
          .indexOf(establishments.toLowerCase()) !== -1;
      let filterStatus =
        item.status
          .toString()
          .toLowerCase()
          .indexOf(getStatus().toLowerCase()) !== -1;
      return filterCode && filterName && filterEstablishment && filterStatus;
    });

    if (cuponsFil && cuponsFil.length === 0) {
      setCouponsFilter(null);

      return;
    }

    setCouponsFilter(cuponsFil);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleInfoCupom = (cupom) => {
    setSelectedCupom(cupom);
    setInfoCupomOpen(true);
  };

  const handleRenewCupom = (cupom) => {
    setSelectedCupom(cupom);
    setRenewCupomOpen(true);
  };

  const openDeleteModal = (cupom) => {
    setSelectedCupom(cupom);
    setDeleteCupomOpen(true);
  };

  const handleCloseDelete = () => {
    setDeleteCupomOpen(false);
  };

  const handleDeleteCupom = async () => {
    setLoading(true);
    const cupomId = selectedCupom ? selectedCupom.id : null;

    await dispatch(removeCupom(cupomId))
      .then(() => {
        getCupons();
        handleCloseDelete();
        handleClickSnackbar();
        setSnackbarMenssage("Cupom removido com sucesso!");
      })
      .catch((e) => console.warn(e));
  };

  const handleStatusCupom = async (cupomId) => {
    setLoading(true);
    try {
      const response = await dispatch(statusCupom(cupomId));
      if (response && response.success) {
        const cuponsResponse = await dispatch(fetchCupons());
        if (cuponsResponse && cuponsResponse.data) {
          setCouponsFilter(cuponsResponse.data);
          setCoupons(cuponsResponse.data);
          setRows(cuponsResponse.data);
        }
        handleClickSnackbar();
        setSnackbarMenssage("Status do cupom alterado com sucesso!");
      }
    } catch (e) {
      console.warn(e);
    } finally {
      setLoading(false);
    }
  };

  const getCupons = async () => {
    await dispatch(fetchCupons())
      .then((response) => {
        setCouponsFilter(response.data);
        setCoupons(response.data);
        setRows(response.data);
        handleCloseDelete();
        setSelectedCupom(null);
        setLoading(false);
      })
      .catch((e) => console.warn(e));
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows =
    rows && rows.length > 0
      ? rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage)
      : 0;

  return (
    <Wrapper>
      <Col1>
        <Title>Cupons</Title>
        <NewProductButton
          className="primary create"
          onClick={() => handleAddCupom()}
        >
          <Icon name="plus" /> Cadastrar Novo
        </NewProductButton>
        <SubTitle>Consultar Cupom</SubTitle>
        <Card>
          <Row>
            <Field>
              <CustomLabel>Código</CustomLabel>
              <Input
                id="code"
                name="code"
                type="text"
                value={code}
                onChange={setCode}
              />
            </Field>
            <Field>
              <CustomLabel>Nome</CustomLabel>
              <Input
                id="name"
                name="name"
                type="text"
                value={name}
                onChange={setName}
              />
            </Field>
            <Field>
              <CustomLabel>Status</CustomLabel>
              <SelectInput
                options={optionStatusCupom}
                selected={status}
                onSelect={setStatus}
              />
            </Field>
          </Row>
          <Row>
            <Field>
              <CustomLabel>Estabelecimento</CustomLabel>
              <Input
                id="name"
                name="name"
                type="text"
                value={establishments}
                onChange={setEstablishments}
              />
            </Field>
          </Row>
          <NewProductButton
            className="primary"
            onClick={() => handleFilterCupons()}
          >
            <Icon name="search" /> Busca Cupom
          </NewProductButton>
        </Card>
        <SubTitle>Cupons Existentes</SubTitle>

        {cuponsFilter && !loading && (
          <Paper className={classes.paper}>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size={dense ? "small" : "medium"}
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  classes={classes}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                />
                <TableBody>
                  {stableSort(cuponsFilter, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.cod);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.cod}
                          selected={isItemSelected}
                        >
                          <TableCell align="center" id={labelId}>
                            {row.cod}
                          </TableCell>
                          <TableCell align="center">{row.name}</TableCell>
                          <TableCell align="center">
                            {row.establishment}
                          </TableCell>
                          <TableCell align="center">{row.app}</TableCell>
                          <TableCell align="center">{row.status}</TableCell>
                          <TableCell>
                            <Action>
                              <CustomIcon
                                onClick={() => handleEditCupom(row.id)}
                              >
                                <Icon
                                  width={"16px"}
                                  height={"16px"}
                                  name={"editCupom"}
                                  stroke={"primary"}
                                  fill={"primary"}
                                />
                              </CustomIcon>
                              <CustomIcon onClick={() => openDeleteModal(row)}>
                                <Icon
                                  width={"16px"}
                                  height={"16px"}
                                  name={"trashCupom"}
                                  stroke={"primary"}
                                  fill={"primary"}
                                />
                              </CustomIcon>
                              <CustomIcon onClick={() => handleRenewCupom(row)}>
                                <Icon
                                  width={"16px"}
                                  height={"16px"}
                                  name={"reloadCupom"}
                                  stroke={"primary"}
                                  fill={"primary"}
                                />
                              </CustomIcon>
                              <CustomIcon onClick={() => handleInfoCupom(row)}>
                                <Icon
                                  width={"16px"}
                                  height={"16px"}
                                  name={"infoCupom"}
                                  stroke={"primary"}
                                />
                              </CustomIcon>
                              {row.status === "Ativo" && (
                                <CustomIcon
                                  onClick={() => handleStatusCupom(row.id)}
                                >
                                  <Icon
                                    width={"16px"}
                                    height={"16px"}
                                    name={"inativeCupom"}
                                    stroke={"primary"}
                                  />
                                </CustomIcon>
                              )}
                              {row.status === "Inativo" && (
                                <CustomIcon
                                  onClick={() => handleStatusCupom(row.id)}
                                >
                                  <Icon
                                    width={"16px"}
                                    height={"16px"}
                                    name={"activeCupom"}
                                    stroke={"primary"}
                                  />
                                </CustomIcon>
                              )}
                            </Action>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[6, 10]}
              component="div"
              count={cuponsFilter.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={"Cupons por página"}
            />
          </Paper>
        )}
        {!cuponsFilter && rows && rows.length > 0 && !loading ? (
          <Paper className={classes.paper}>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size={dense ? "small" : "medium"}
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  classes={classes}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                />
                <TableBody>
                  {stableSort(rows, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.cod);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.cod}
                          selected={isItemSelected}
                        >
                          <TableCell align="center" id={labelId}>
                            {row.cod}
                          </TableCell>
                          <TableCell align="center">{row.name}</TableCell>
                          <TableCell align="center">
                            {row.establishment}
                          </TableCell>
                          <TableCell align="center">{row.app}</TableCell>
                          <TableCell align="center">{row.status}</TableCell>
                          <TableCell>
                            <Action>
                              <CustomIcon
                                onClick={() => handleEditCupom(row.id)}
                              >
                                <Icon
                                  width={"16px"}
                                  height={"16px"}
                                  name={"editCupom"}
                                  stroke={"primary"}
                                  fill={"primary"}
                                />
                              </CustomIcon>
                              <CustomIcon onClick={() => openDeleteModal(row)}>
                                <Icon
                                  width={"16px"}
                                  height={"16px"}
                                  name={"trashCupom"}
                                  stroke={"primary"}
                                  fill={"primary"}
                                />
                              </CustomIcon>
                              <CustomIcon onClick={() => handleRenewCupom(row)}>
                                <Icon
                                  width={"16px"}
                                  height={"16px"}
                                  name={"reloadCupom"}
                                  stroke={"primary"}
                                  fill={"primary"}
                                />
                              </CustomIcon>
                              <CustomIcon onClick={() => handleInfoCupom(row)}>
                                <Icon
                                  width={"16px"}
                                  height={"16px"}
                                  name={"infoCupom"}
                                  stroke={"primary"}
                                />
                              </CustomIcon>
                              {row.status === "Ativo" && (
                                <CustomIcon
                                  onClick={() => handleStatusCupom(row.id)}
                                >
                                  <Icon
                                    width={"16px"}
                                    height={"16px"}
                                    name={"inativeCupom"}
                                    stroke={"primary"}
                                  />
                                </CustomIcon>
                              )}
                              {row.status === "Inativo" && (
                                <CustomIcon
                                  onClick={() => handleStatusCupom(row.id)}
                                >
                                  <Icon
                                    width={"16px"}
                                    height={"16px"}
                                    name={"activeCupom"}
                                    stroke={"primary"}
                                  />
                                </CustomIcon>
                              )}
                            </Action>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[6, 10]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={"Cupons por página"}
            />
          </Paper>
        ) : loading ? (
          <LoadingWrapper>
            <Loading />
          </LoadingWrapper>
        ) : !cuponsFilter ? (
          <CustomAlert>Nenhum cupom cadastrado</CustomAlert>
        ) : (
          <></>
        )}

        <InfoCupomModal
          isOpen={infoCupomOpen}
          onClose={() => {
            setInfoCupomOpen(false);
            setSelectedCupom(null);
          }}
          cupomId={selectedCupom ? selectedCupom.id : null}
        />

        <RenewCupomModal
          isOpen={renewCupomOpen}
          onClose={() => {
            setRenewCupomOpen(false);
            setSelectedCupom(null);
          }}
          cupomName={selectedCupom ? selectedCupom.name : null}
          cupomId={selectedCupom ? selectedCupom.id : null}
        />

        <Dialog
          open={deleteCupomOpen}
          onClose={handleCloseDelete}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          maxWidth={"xs"}
        >
          <DialogContent>
            <ModalWrapper>
              <Span>
                Deseja mesmo deletar o cupom{" "}
                <Strong>{selectedCupom ? selectedCupom.name : ""}</Strong> ?
              </Span>
              <DeleteButton
                className="error center"
                onClick={handleDeleteCupom}
              >
                Deletar
              </DeleteButton>
            </ModalWrapper>
          </DialogContent>
        </Dialog>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
        >
          <Alert onClose={handleCloseSnackbar} severity="success">
            {snackbarMenssage}
          </Alert>
        </Snackbar>
      </Col1>
    </Wrapper>
  );
};

export default CouponsSearchPage;
